<script lang="ts">
    import type { HTMLAttributes } from "svelte/elements";
    import type { WithElementRef } from "../../../utils.js";
    import DotIcon from "@lucide/svelte/icons/dot";

    let { ref = $bindable(null), children, ...restProps }: WithElementRef<HTMLAttributes<HTMLDivElement>> = $props();
</script>

<div bind:this={ref} data-slot="input-otp-separator" role="separator" {...restProps}>
    {#if children}
        {@render children?.()}
    {:else}
        <DotIcon />
    {/if}
</div>
